import {MenuItem, Typography} from "@mui/material"
import LabeledSelect          from "../LabeledSelect"
import {PRODUCT_TYPES}        from "../../util/product-types"

/**
 * Select for product.product_type. Types are a fixed list, so unlike SelectCategory
 * there is nothing to fetch.
 *
 * @param productType   the currently selected type token, or null/'' for none
 * @param onChangeProductType  called with the selected token
 * @param label         select label, defaults to "Product Type"
 */
const SelectProductType = ({productType, onChangeProductType, label = "Product Type", sx}) => {

	return <LabeledSelect
		sx={sx}
		value={productType || ''}
		onChange={e => onChangeProductType(e.target.value)}
		displayEmpty
		fullWidth
		label={label}
	>
		<MenuItem value="">
			<Typography component="span" style={{opacity: 0.5}}>
				Select Product Type
			</Typography>
		</MenuItem>
		{
			PRODUCT_TYPES.map(t => (
				<MenuItem key={t.token} value={t.token}>
					<Typography component="span">
						{t.label}
					</Typography>
				</MenuItem>
			))
		}
	</LabeledSelect>
}

export default SelectProductType
